/* ---------------------------------------------------------------------------
   Custom Calendar — collapsible featured copy ("Read more")
   ---------------------------------------------------------------------------
   Progressive enhancement. Without this script the full copy is visible and
   the toggle button stays hidden (the markup ships that way). This script:
     1. Clamps the copy to the merchant's line setting (via .is-collapsible).
     2. Reveals the "Read more" button ONLY if the copy actually overflows.
     3. On expand, freezes the media height so growing text can't stretch the
        image; restores it on collapse.
     4. Auto-collapses when the section scrolls fully out of view
        (disabled in the theme editor).
   Safe to run more than once — initialised wraps are marked and skipped.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var OVERFLOW_TOLERANCE = 2; // px, guards against sub-pixel rounding

  function isEditor() {
    return (
      (window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode')
    );
  }

  function initCopy(wrap) {
    if (!wrap || wrap.dataset.calReady === '1') return;

    var copy = wrap.querySelector('[data-cal-copy]');
    var btn = wrap.querySelector('[data-cal-copy-toggle]');
    if (!copy || !btn) return;

    wrap.dataset.calReady = '1';

    var moreLabel = wrap.getAttribute('data-more-label') || 'Read more';
    var lessLabel = wrap.getAttribute('data-less-label') || 'Read less';

    // Apply the clamp, then measure whether the copy is actually cut off.
    wrap.classList.add('is-collapsible');
    var overflowing = copy.scrollHeight > copy.clientHeight + OVERFLOW_TOLERANCE;

    if (!overflowing) {
      // Short copy — no clamp, no button.
      wrap.classList.remove('is-collapsible');
      return;
    }

    btn.hidden = false;
    btn.textContent = moreLabel;
    btn.setAttribute('aria-expanded', 'false');

    var featured = wrap.closest('.calendar__featured');
    var media = featured ? featured.querySelector('.calendar__media') : null;
    var section = wrap.closest('.calendar');

    function open() {
      // Freeze the media at its current (collapsed-match) height first, so the
      // longer text grows without pulling the image taller.
      if (media) media.style.height = media.offsetHeight + 'px';
      wrap.classList.add('is-open');
      if (featured) featured.classList.add('is-copy-open');
      btn.textContent = lessLabel;
      btn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      wrap.classList.remove('is-open');
      if (featured) featured.classList.remove('is-copy-open');
      if (media) media.style.height = '';
      btn.textContent = moreLabel;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function () {
      if (wrap.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    // Auto-collapse once the section is fully out of view (skip in the editor).
    if (!isEditor() && section && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && wrap.classList.contains('is-open')) {
              close();
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(section);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll('[data-cal-copy-wrap]');
    for (var i = 0; i < wraps.length; i++) initCopy(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
